import React from "react";

import { classNames } from "../../../../utils/classNames";

export const Container: React.FC<React.PropsWithChildren<{ className?: string }>> = ({ children, className }) => {
    return <div className={classNames("mx-auto max-w-6xl px-4 sm:px-6 lg:px-8", className)}>{children}</div>;
};
